import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "../../components/Pagination";
import { getTestRunStatusInfoCloseLoop } from "../../components/UserFunctions"
import { addTestRunStatusFromAPI } from "../../actions/closeLoop/testRunStatusActionCloseLoop"
import TestRunStatusTable from "../../components/closedLoop/TestRunStatusTableCloseLoop"
import PropTypes from 'prop-types';

class TestRunStatusCloseLoop extends Component {
//    constructor(props){
//        super(props)
//    }
//
    componentDidMount() {
        getTestRunStatusInfoCloseLoop(1).then(response => {
            if(response){
                this.props.dispatch(addTestRunStatusFromAPI(response))
                console.log('testRunStatus length : ', this.props.testRunStatus.length)

            } else{
                this.props.dispatch(addTestRunStatusFromAPI({testRunStatus: [],
                                                            pages: [],
                                                            currentPage: 0 }))
            }
        })
    }


    render() {
        return(
            <div className="container-fluid">
                <div className="row">
                  <div className="mt-5 mx-auto">
                    <div className="card" style={{backgroundColor: "white"}}>
                        <div className="card">
                            <h1 className="card-header" style={{color:"white", fontSize: "100% !important", backgroundColor: "#757AF7"}}>Test Run Status</h1>
                        </div>
                            <div className="card-body">
                                {/* <div className="table col-md-6 mx-auto"> */}
                                <div className="table">
                                    <TestRunStatusTable testRunStatus = {this.props.testRunStatus} />
                                </div>
                            </div>
                      </div>
                  </div>
                </div>
                <div>
                {this.props.testRunStatus.length > 0 ?
                 <Pagination
                    currentPage={this.props.currentPage}
                    pages={this.props.pages}
                    getApiInfo={getTestRunStatusInfoCloseLoop}
                    action={addTestRunStatusFromAPI}
                 />
                 : undefined}
                </div>
              </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        testRunStatus: state.testRunStatus_close_loop.testRunStatus,
        currentPage: state.testRunStatus_close_loop.currentPage,
        pages: state.testRunStatus_close_loop.pages
    }
}
TestRunStatusCloseLoop.propTypes={
dispatch:PropTypes.string,
testRunStatus:PropTypes.string,
currentPage:PropTypes.string,
pages:PropTypes.string,
}
TestRunStatusCloseLoop.defaultProps= {
dispatch:[],
testRunStatus:[],
currentPage:[],
pages:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default connect(mapStateToProps)(TestRunStatusCloseLoop);
